import React, {useState} from 'react';
import {useStyles} from "./styles/SupportStyle";
import Inquiry from "./inquiry/Inquiry";
import FAQ from "./faq/FAQ";
import Info from "./info/Info";
import {useMediaQuery} from "@material-ui/core";
import {Tab, Tabs} from "@material-ui/core";
import TabPanel from "../../../components/TabPanel";
import Footer from "./Footer";

const tabEnum = {
    Info: {
        name: 'Info',
        value: 0,
        component: <Info/>
    },
    Inquiry: {
        name: 'Inquiry',
        value: 1,
        component: <Inquiry/>
    },
    FAQ: {
        name: 'FAQ',
        value: 2,
        component: <FAQ/>

    }
}

function a11yProps(index) {
    return {
        id: `support-tab-${index}`,
        'aria-controls': `support-tabpanel-${index}`,
    };
}

export default function Support() {
    const classes = useStyles();
    const isMobile = useMediaQuery("(max-width: 1000px)");
    const [selectedTab, setSelectedTab] = useState(tabEnum.Info.value);

    const changeTab = (e, val) => {
        setSelectedTab(val);
    }

    const displayTabs = () => {
        return (
            <Tabs value={selectedTab} onChange={changeTab} aria-label="support tabs example">
                <Tab label={tabEnum.Info.name} {...a11yProps(tabEnum.Info.value)} disableRipple/>
                <Tab label={tabEnum.Inquiry.name} {...a11yProps(tabEnum.Inquiry.value)} disableRipple/>
                <Tab label={tabEnum.FAQ.name} {...a11yProps(tabEnum.FAQ.value)} disableRipple/>
            </Tabs>
        )
    }

    const displayTabPanel = () => {
        return Object.values(tabEnum).map((tab, index) => (
            <React.Fragment key={index}>
                {selectedTab === tab.value &&
                    <TabPanel key={index} value={selectedTab} index={tab.value} className={classes.supportContainer}>
                        {tab.component}
                    </TabPanel>
                }
            </React.Fragment>
        ))
    }

    const displayFooter = () => {
        return (
            <div className={classes.footerRoot}>
                <Footer/>
            </div>
        )
    }

    return (
        <div className={classes.root}>
            <div className={isMobile ? classes.mobileContainer : classes.container}>
                <div className={classes.header}>Support</div>
                {displayTabs()}
                <div className={classes.tabPanelContainer}>
                    {displayTabPanel()}
                </div>
            </div>
            {displayFooter()}
        </div>
    );
}
